/**
 * 汇率卡片组件
 * 职责: 显示单个货币的汇率信息
 * 限制: <100行
 */

import React from 'react';
import { Card } from 'antd';
import { DollarOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import type { LatestRate } from '../../../types/exchange-rate-types';

interface RateCardProps {
    rate: LatestRate;
    color: string;
}

export const RateCard: React.FC<RateCardProps> = ({ rate, color }) => {
    const isPositive = (rate.change_percent || 0) >= 0;

    return (
        <Card
            variant="borderless"
            hoverable
            style={{
                borderRadius: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                overflow: 'hidden',
                position: 'relative'
            }}
            styles={{ body: { padding: '20px 24px' } }}
        >
            {/* 装饰性背景条 */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                backgroundColor: color
            }} />

            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start'
            }}>
                <div>
                    <div style={{
                        color: '#8c8c8c',
                        fontSize: 14,
                        marginBottom: 4,
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                        <DollarOutlined style={{ marginRight: 4 }} />
                        1 {rate.currency} =
                    </div>
                    <div style={{
                        fontSize: 28,
                        fontWeight: 600,
                        color: '#262626',
                        fontFamily: 'DIN Alternate, monospace'
                    }}>
                        <span style={{ fontSize: 16, marginRight: 2 }}>¥</span>
                        {Number(rate.rate).toFixed(4)}
                    </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <div style={{
                        color: isPositive ? '#52c41a' : '#f5222d',
                        backgroundColor: isPositive ?
                            'rgba(82, 196, 26, 0.1)' :
                            'rgba(245, 34, 45, 0.1)',
                        padding: '4px 8px',
                        borderRadius: 6,
                        display: 'inline-flex',
                        alignItems: 'center',
                        fontSize: 13,
                        fontWeight: 500
                    }}>
                        {isPositive ?
                            <ArrowUpOutlined style={{ fontSize: 12, marginRight: 2 }} /> :
                            <ArrowDownOutlined style={{ fontSize: 12, marginRight: 2 }} />
                        }
                        {Math.abs(rate.change_percent || 0).toFixed(2)}%
                    </div>
                    <div style={{ fontSize: 12, color: '#bfbfbf', marginTop: 6 }}>
                        较昨日
                    </div>
                </div>
            </div>
        </Card>
    );
};
